import { GoogleAuthProvider, getAdditionalUserInfo, signInWithPopup } from 'firebase/auth'
import { Request, Translation, ScrollTop } from '@/helpers'
import { FirebaseAuth } from '@/services'

import {
    COMPONENT_DEFUALT_FILTERS,
    COMPONENT_DEFAULT_ERRORS,
    COMPONENT_DEFAULT_FORM,
    ENDPOINTS
} from '@/data'

const AuthInvoke = async (
    User: UserInterface | null,
    SmallLoading: boolean,
    SetState: Function,
    Notification: Function,
    push: Function,
    SideoverSetState: Function,
    CategorySetState: Function,
    ComponentSetState: Function,
    TagSetState: Function
) => {
    if (!SmallLoading && !User) {
        try {
            SetState({ SmallLoading: true })

            const FirebaseProvider = new GoogleAuthProvider()

            const result = await signInWithPopup(FirebaseAuth, FirebaseProvider)
            const isNewUser = getAdditionalUserInfo(result)?.isNewUser
            const user: any = result.user

            if (user) {
                const formatted_domain_of_email = user?.email?.split('@')[1]
                let isVaild = formatted_domain_of_email?.toLowerCase() === 'azwedo.com'

                if (user?.email === 'blodinselimi@gmail.com') isVaild = true
                if (user?.email === 'donatbytyqi2@gmail.com') isVaild = true

                if (isVaild) {
                    const response = await Request({
                        path: ENDPOINTS.AUTH,
                        method: 'POST',
                        body: {
                            name: user.displayName,
                            email: user.email,
                            avatar: user.photoURL
                        }
                    })

                    if (response) {
                        const { success, data, message } = response

                        if (success) SetState({
                            User: data,
                            SmallLoading: false,
                            Loading: false
                        })

                        else {
                            ScrollTop()

                            await FirebaseAuth.signOut()

                            SetState({
                                User: false,
                                SmallLoading: false,
                                Loading: false
                            })

                            SideoverSetState({
                                Form: COMPONENT_DEFAULT_FORM,
                                Errors: COMPONENT_DEFAULT_ERRORS,
                                Open: false,
                                Loading: false
                            })

                            CategorySetState({
                                Categories: [],
                                Loading: false
                            })

                            TagSetState({
                                Categories: [],
                                Loading: false
                            })

                            ComponentSetState({
                                Components: [],
                                Loading: false,
                                Filters: COMPONENT_DEFUALT_FILTERS
                            })

                            Notification(message)

                            push('/')
                        }
                    }

                    else {
                        ScrollTop()

                        await FirebaseAuth.signOut()

                        SetState({
                            User: false,
                            SmallLoading: false,
                            Loading: false
                        })

                        SideoverSetState({
                            Form: COMPONENT_DEFAULT_FORM,
                            Errors: COMPONENT_DEFAULT_ERRORS,
                            Open: false,
                            Loading: false
                        })

                        CategorySetState({
                            Categories: [],
                            Loading: false
                        })

                        TagSetState({
                            Categories: [],
                            Loading: false
                        })

                        ComponentSetState({
                            Components: [],
                            Loading: false,
                            Filters: COMPONENT_DEFUALT_FILTERS
                        })

                        Notification(Translation('something-went-wrong-while-trying-to-auth-the-user'))

                        push('/')
                    }
                }

                else {
                    if (isNewUser) await user.delete()

                    ScrollTop()

                    await FirebaseAuth.signOut()

                    SetState({
                        User: false,
                        SmallLoading: false,
                        Loading: false
                    })

                    SideoverSetState({
                        Form: COMPONENT_DEFAULT_FORM,
                        Errors: COMPONENT_DEFAULT_ERRORS,
                        Open: false,
                        Loading: false
                    })

                    CategorySetState({
                        Categories: [],
                        Loading: false
                    })

                    TagSetState({
                        Categories: [],
                        Loading: false
                    })

                    ComponentSetState({
                        Components: [],
                        Loading: false,
                        Filters: COMPONENT_DEFUALT_FILTERS
                    })

                    Notification(Translation('only-internal-emails-are-allowed-to-use-the-app'))

                    push('/')
                }
            }

            else {
                ScrollTop()

                await FirebaseAuth.signOut()

                SetState({
                    User: false,
                    SmallLoading: false,
                    Loading: false
                })

                SideoverSetState({
                    Form: COMPONENT_DEFAULT_FORM,
                    Errors: COMPONENT_DEFAULT_ERRORS,
                    Open: false,
                    Loading: false
                })

                CategorySetState({
                    Categories: [],
                    Loading: false
                })

                TagSetState({
                    Categories: [],
                    Loading: false
                })

                ComponentSetState({
                    Components: [],
                    Loading: false,
                    Filters: COMPONENT_DEFUALT_FILTERS
                })

                push('/')
            }
        }

        catch (err: any) {
            const message = err.message || err
            if (!message.includes('popup-closed-by-user')) Notification(Translation('something-went-wrong-while-trying-to-auth-the-user'))

            SetState({
                User: false,
                SmallLoading: false,
                Loading: false
            })

            CategorySetState({
                Categories: [],
                Loading: false
            })

            TagSetState({
                Categories: [],
                Loading: false
            })

            SideoverSetState({
                Form: COMPONENT_DEFAULT_FORM,
                Errors: COMPONENT_DEFAULT_ERRORS,
                Open: false,
                Loading: false
            })

            ComponentSetState({
                Components: [],
                Loading: false,
                Filters: COMPONENT_DEFUALT_FILTERS
            })

            push('/')
        }
    }
}

export default AuthInvoke
